import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable react/no-unknown-property */
import { useRef } from 'react';
import { useFrame, useThree } from '@react-three/fiber';
import { getXRModule } from './xrModule.js';
const { useXRInputSourceState } = getXRModule();
// XRHand is typed as Map<number, XRJointSpace> in TS lib, but the WebXR spec
// and runtime use string joint names. This helper casts for string-keyed access.
function getHandJoint(hand, jointName) {
    return hand.get(jointName);
}
export function HandBbox() {
    const rightHand = useXRInputSourceState('hand', 'right');
    const leftHand = useXRInputSourceState('hand', 'left');
    const rightTipRef = useRef(null);
    const leftTipRef = useRef(null);
    const { gl } = useThree();
    useFrame((_state, _delta, frame) => {
        if (!frame || !gl.xr.isPresenting)
            return;
        const refSpace = gl.xr.getReferenceSpace();
        if (!refSpace)
            return;
        if (rightHand?.inputSource?.hand && rightTipRef.current) {
            const jointSpace = getHandJoint(rightHand.inputSource.hand, 'index-finger-tip');
            if (jointSpace) {
                const pose = frame.getJointPose?.(jointSpace, refSpace);
                if (pose) {
                    rightTipRef.current.position.set(pose.transform.position.x, pose.transform.position.y, pose.transform.position.z);
                }
            }
        }
        if (leftHand?.inputSource?.hand && leftTipRef.current) {
            const jointSpace = getHandJoint(leftHand.inputSource.hand, 'index-finger-tip');
            if (jointSpace) {
                const pose = frame.getJointPose?.(jointSpace, refSpace);
                if (pose) {
                    leftTipRef.current.position.set(pose.transform.position.x, pose.transform.position.y, pose.transform.position.z);
                }
            }
        }
    });
    return (_jsxs(_Fragment, { children: [_jsxs("mesh", { name: "leftTipBbox", ref: leftTipRef, children: [_jsx("boxGeometry", { args: [0.02, 0.02, 0.02] }), _jsx("meshStandardMaterial", { color: "blue", transparent: true, opacity: 0 })] }), _jsxs("mesh", { name: "rightTipBbox", ref: rightTipRef, children: [_jsx("boxGeometry", { args: [0.02, 0.02, 0.02] }), _jsx("meshStandardMaterial", { color: "orange", transparent: true, opacity: 0 })] })] }));
}
//# sourceMappingURL=HandBbox.js.map